import React, { PropsWithChildren } from 'react';
import LinkIcon from '@mui/icons-material/Link';
import PrintIcon from '@mui/icons-material/Print';
import { i18n_share } from '@yi/i18n/phrases/i18n_share';

import { utilities } from '~/common';
import { IconSocialFacebookFooter, IconSocialTwitterFooter } from '~/src/components/icons';
import { useLocale } from '~/src/components/LocaleProvider';

import {
  IconGroupWrapper,
  IconWrapper,
  Button,
  Container,
  Text,
  OrangeIconWrapper,
  LinkIconWrapper,
} from './elements';

interface Props {
  content: {
    title: string;
    full_url: string;
  };
}

const { getFbAndTwitterShareLinks } = utilities;
export const ShareIcons: React.FC<PropsWithChildren<Props>> = ({
  content: { title, full_url },
}) => {
  const { locale } = useLocale();

  const { facebookLink, twitterLink } = getFbAndTwitterShareLinks({ full_url, title });
  return (
    <Container>
      <Text>{`${i18n_share(locale)}:`}</Text>
      <IconGroupWrapper>
        <a
          data-platform-name="Facebook"
          data-media-title={title}
          href={facebookLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on Facebook"
        >
          <IconWrapper>
            <IconSocialFacebookFooter />
          </IconWrapper>
        </a>

        <a
          data-platform-name="Twitter"
          data-media-title="{title}"
          href={twitterLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on Twitter"
        >
          <IconWrapper>
            <IconSocialTwitterFooter />
          </IconWrapper>
        </a>

        <Button onClick={() => navigator.clipboard.writeText(full_url)} aria-label="Copy link">
          <LinkIconWrapper>
            <LinkIcon
              style={{
                width: '20px',
                height: '20px',
                color: 'white',
              }}
            />
          </LinkIconWrapper>
        </Button>
        <Button onClick={() => window.print()} aria-label="Print">
          <OrangeIconWrapper>
            <PrintIcon
              style={{
                width: '20px',
                height: '20px',
                color: 'white',
              }}
            />
          </OrangeIconWrapper>
        </Button>
      </IconGroupWrapper>
    </Container>
  );
};
